/* eslint-disable no-loop-func, no-case-declarations, no-console */
import { ApolloClient, from, HttpLink } from '@apollo/client';
import { Box, Chip, Typography } from '@mui/material';
import { HashStraightIcon } from '@phosphor-icons/react';
import toast from 'react-hot-toast';

import { GQL_URI } from '../constants/environment';
import { typeDefs } from '../graphql/local/typeDefs';
import { appVersion, isFirstLoad, isSameBuild } from './buildInfo';
import { cache } from './cache';
import { checkAuthMiddleware } from './checkAuthMiddleware';
import { errorMiddleware } from './errorLink';

const httpLink = new HttpLink({ uri: GQL_URI });

export const createApolloClient = async (): Promise<ApolloClient<unknown>> => {
  const client = new ApolloClient({
    cache,
    link: from([checkAuthMiddleware, errorMiddleware, httpLink]),
    typeDefs, // Local schema
  });

  const shouldClear = !isSameBuild && !isFirstLoad;
  if (shouldClear) {
    toast.success(() => (
      <Box flexDirection="column">
        <Typography variant="body1">App updated to version</Typography>
        <Chip
          color="info"
          icon={<HashStraightIcon />}
          label={appVersion}
          size="small"
          sx={{ mt: 1 }}
          variant="outlined"
        />
      </Box>
    ));
    await client.resetStore();
  }

  return client;
};
